import type { PageLoad } from "./$types"

// This client-side load function runs before the component mounts
// It ensures we have at least a placeholder for the game data
export const load: PageLoad = async ({ data, params }) => {
  // If we already have data from the server, return it
  if (data && data.game) {
    return data
  }

  // Otherwise, return a placeholder that shows we're loading
  return {
    game: {
      gameName: params.slug
          .split("-")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
      loading: true,
    },
  }
}

